import routes from 'constants/routes';

export function getInsightsSectionNameByRoute(route: string) {
  switch (route) {
    case routes.INSIGHTS:
    case routes.INSIGHTS_POSTS_PERFORMANCE:
      return 'posts-performance';
    case routes.INSIGHTS_PAGE_PERFORMANCE:
      return 'page-performance';
    case routes.INSIGHTS_COMPETITION_ANALYSIS:
      return 'competition-analysis';
    default:
      return '';
  }
}
